import { objectToSelectOptions } from '@monorepo/tools/src/lib/utils/object';
import { FilterTypeKey, FilterType, IStringFilter, IEnumFilter } from '../../components/filters';
import countriesJson from '@monorepo/tools/src/lib/consts/geos.json';
export const myLinksFilters = new Map<FilterTypeKey, FilterType>([
	[
		'stringFilters',
		{
			domain: { columnName: 'Domain', cellKey: 'domain' },
			trackingUrl: { columnName: 'Tracking URL', cellKey: 'trackingUrl' },
		} as IStringFilter,
	],
	[
		'enumFilters',
		{
			geo: {
				columnName: 'Geo',
				cellKey: 'geo',
				enumOptions: objectToSelectOptions(countriesJson),
				deletable: true,
			},
			linkType: {
				columnName: 'Link Type',
				cellKey: 'linkType',
				enumOptions: [
					{ value: 'HP', label: 'HP' },
					{ value: 'DL', label: 'DL' },
				],
				deletable: true,
			},
			displayStatus: {
				columnName: 'Status',
				cellKey: 'displayStatus',
				enumOptions: [
					{ value: 'Active', label: 'Active' },
					{ value: 'Inactive', label: 'Inactive' },
					{ value: 'Stopped', label: 'Stopped' },
					{ value: 'Stopped by Manager', label: 'Stopped by Manager' },
				],
				deletable: true,
			},
		} as IEnumFilter,
	],
]);
